/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShareAndroidIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Share Android',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15,13.24998c-.76807,0-1.46167.31799-1.96106.82727l-6.35681-3.48535c.04224-.19116.06787-.38831.06787-.59192s-.02563-.40076-.06787-.59192l6.35681-3.48535c.49939.50928,1.19299.82727,1.96106.82727,1.5166,0,2.75-1.2334,2.75-2.75s-1.2334-2.75-2.75-2.75-2.75,1.2334-2.75,2.75c0,.20703.02722.40698.0708.60107l-6.35107,3.48657c-.50012-.51489-1.19678-.83765-1.96973-.83765-1.5166,0-2.75,1.2334-2.75,2.75s1.2334,2.75,2.75,2.75c.77295,0,1.4696-.32275,1.96973-.83765l6.35107,3.48657c-.04358.19409-.0708.39404-.0708.60107,0,1.5166,1.2334,2.75,2.75,2.75s2.75-1.2334,2.75-2.75-1.2334-2.75-2.75-2.75ZM15,2.74998c.68945,0,1.25.56055,1.25,1.25s-.56055,1.25-1.25,1.25-1.25-.56055-1.25-1.25.56055-1.25,1.25-1.25ZM2.75,9.99998c0-.68945.56055-1.25,1.25-1.25s1.25.56055,1.25,1.25-.56055,1.25-1.25,1.25-1.25-.56055-1.25-1.25ZM15,17.24998c-.68945,0-1.25-.56055-1.25-1.25s.56055-1.25,1.25-1.25,1.25.56055,1.25,1.25-.56055,1.25-1.25,1.25Z"
      fill="currentColor"
    />
  </svg>`;
};
